<!--  -->
<template>
  <div>
    <div style="margin-bottom: 20px;" class="search_box">
      <el-input v-model="query.keywords" class="inptw" style="width: 300px;" placeholder="请输入员工编号和名称" />
      <el-select v-model="query.onlyMe" placeholder="请选择" style="width: 300px;">
        <el-option
          v-for="item in accountarr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button type="primary" class="searchurl" icon="el-icon-search" @click="searchclick">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="name"
        label="员工姓名"
        width="350"
        align="center"
      />
      <el-table-column
        prop="employee_no"
        label="员工编号"
        width="300"
        align="center"
      />
      <el-table-column
        prop="corp_name"
        label="企业名称"
        width="400"
        align="center"
      />
      <el-table-column
        prop="corp_id"
        label="企业编号"
        width="320"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="chooser(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { corpUsersList } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      obj: {},
      tableData: [],
      query: {
        page: 1,
        page_size: 10,
        onlyMe: 2,
        keywords: null
      },
      total: null,
      loading: false,
      accountarr: [{
        value: 1,
        label: '查看组内员工'
      }, {
        value: 2,
        label: '我关联的员工'
      }]
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async list() {
      this.loading = true
      const data = await corpUsersList(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    send(obj) {
      this.obj = obj
      this.list()
    },
    chooser(item) {
      this.$emit('staffcallback', item)
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    reset() {
      this.query.page = 1
      this.query.onlyMe = 2
      this.query.keywords = null
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.searchurl{
  margin-left: 10px;
}
</style>
